/**
 * Regar Switzerland Official Theme Scripts
 * - Flawless Multilingual Engine (EN, DE, FR) for Desktop & Mobile
 * - Seamless Shopify Route Redirection (/de, /fr, /)
 * - Complete Frontend Translation (Buttons, Headers, Modals, Countdowns, Cart)
 * - Ticket Checker Modal & Live Verification Logic
 */

document.addEventListener('DOMContentLoaded', () => {
  // -------------------------------------------------------------
  // 1. MULTILINGUAL DICTIONARY & SVG FLAGS
  // -------------------------------------------------------------
  const FLAGS_DESKTOP = {
    en: `<svg width="18" height="12" viewBox="0 0 60 30" aria-hidden="true" class="block w-full h-full"><clipPath id="act_flag_uk_s"><path d="M0,0 v30 h60 v-30 z"/></clipPath><clipPath id="act_flag_uk_t"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/></clipPath><g clip-path="url(#act_flag_uk_s)"><path d="M0,0 v30 h60 v-30 z" fill="#012169"/><path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" stroke-width="6"/><path d="M0,0 L60,30 M60,0 L0,30" clip-path="url(#act_flag_uk_t)" stroke="#C8102E" stroke-width="4"/><path d="M30,0 v30 M0,15 h60" stroke="#fff" stroke-width="10"/><path d="M30,0 v30 M0,15 h60" stroke="#C8102E" stroke-width="6"/></g></svg>`,
    de: `<svg width="18" height="12" viewBox="0 0 18 12" aria-hidden="true" class="block w-full h-full"><rect width="18" height="4" fill="#000000"/><rect y="4" width="18" height="4" fill="#DD0000"/><rect y="8" width="18" height="4" fill="#FFCE00"/></svg>`,
    fr: `<svg width="18" height="12" viewBox="0 0 18 12" aria-hidden="true" class="block w-full h-full"><rect width="6" height="12" fill="#0055A4"/><rect x="6" width="6" height="12" fill="#FFFFFF"/><rect x="12" width="6" height="12" fill="#EF4135"/></svg>`
  };

  const FLAGS_MOBILE = {
    en: `<svg width="16" height="10" viewBox="0 0 60 30" aria-hidden="true" class="block w-full h-full"><clipPath id="mob_act_uk_s"><path d="M0,0 v30 h60 v-30 z"/></clipPath><clipPath id="mob_act_uk_t"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/></clipPath><g clip-path="url(#mob_act_uk_s)"><path d="M0,0 v30 h60 v-30 z" fill="#012169"/><path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" stroke-width="6"/><path d="M0,0 L60,30 M60,0 L0,30" clip-path="url(#mob_act_uk_t)" stroke="#C8102E" stroke-width="4"/><path d="M30,0 v30 M0,15 h60" stroke="#fff" stroke-width="10"/><path d="M30,0 v30 M0,15 h60" stroke="#C8102E" stroke-width="6"/></g></svg>`,
    de: `<svg width="16" height="10" viewBox="0 0 18 12" aria-hidden="true" class="block w-full h-full"><rect width="18" height="4" fill="#000000"/><rect y="4" width="18" height="4" fill="#DD0000"/><rect y="8" width="18" height="4" fill="#FFCE00"/></svg>`,
    fr: `<svg width="16" height="10" viewBox="0 0 18 12" aria-hidden="true" class="block w-full h-full"><rect width="6" height="12" fill="#0055A4"/><rect x="6" width="6" height="12" fill="#FFFFFF"/><rect x="12" width="6" height="12" fill="#EF4135"/></svg>`
  };

  const translations = {
    en: {
      label: 'EN',
      // Nav
      nav_products: 'Products',
      nav_raffles: 'Raffles',
      nav_winners: 'Winners',
      nav_faq: 'FAQ',
      nav_contact: 'Contact',
      check_tickets: '🎟️ Check Tickets',
      mob_tickets: '🎟️ Tickets',
      nav_home: 'Home',
      nav_shop: 'Shop',
      nav_tickets: 'Tickets',
      nav_account: 'Account',
      nav_login: 'Login',
      // Hero
      hero_title_1: 'BUY A WHITERAX',
      hero_title_2: 'WIN A ROLEX',
      hero_sub: 'Buy 1 pack of Whiterax teeth-whitening patches for CHF 29.90 → receive 1 entry into the monthly prize draw → get the chance to win the Rolex.',
      buy_now: 'BUY NOW',
      buy_and_enter: 'BUY & ENTER',
      buy_and_enter_draw: 'BUY & ENTER DRAW',
      enter_rolex_draw: 'ENTER ROLEX DRAW • CHF 29.90',
      enter_draw_short: 'Enter Rolex Draw',
      enter_current_draw: 'ENTER CURRENT DRAW',
      add_to_cart: 'ADD TO CART',
      checkout: 'PROCEED TO CHECKOUT →',
      continue_shopping: '← Continue Shopping',
      update_cart: 'Update Cart',
      subscribe: 'SUBSCRIBE',
      view_all: 'VIEW ALL',
      verify: 'Verify',
      close: 'Close',
      // Countdown
      countdown_ends: 'ROLEX DRAW ENDS IN',
      days: 'Days',
      hours: 'Hours',
      min: 'Min',
      sec: 'Sec',
      // How it works
      how_it_works: 'HOW IT WORKS',
      how_it_works_eyebrow: 'HOW IT WORKS',
      how_it_works_heading: 'Simple steps to win',
      step1_title: 'Purchase',
      step1_desc: 'Choose your Whiterax product and complete your order.',
      step2_title: 'Get Entries',
      step2_desc: 'Every paid order automatically adds your entries to the monthly raffle.',
      step3_title: 'Win Big',
      step3_desc: 'Wait for the official draw and get the chance to win the Rolex.',
      // Shop
      shop_eyebrow: 'SHOP WHITERAX TEETH WHITENING STRIPS',
      shop_heading: 'Choose Your Whitening Strips',
      prizes_eyebrow: 'AMAZING PRIZES',
      prizes_heading: 'Win Life-Changing Prizes',
      past_winners: 'Our Latest Winners',
      verified_community: 'Verified Community',
      faq_eyebrow: 'FREQUENTLY ASKED QUESTIONS',
      faq_heading: 'Got Questions? We Have Answers',
      // Ticket Checker Modal
      checker_title: 'Raffle Ticket Verifier',
      checker_sub: 'Enter your Shopify Order Number (e.g. #1001), Ticket Number (e.g. REG-ROLEX-1002-T01), or Email to verify your official Rolex Submariner draw entries.',
      checker_placeholder: 'e.g. #1002 or marc.weber@bluewin.ch',
      active_entry: 'Active Entry',
      verified_entry: 'Verified Swiss Entry',
      // Trust & Product
      free_shipping: 'Free Delivery',
      in_stock: 'In Stock - Ships Tomorrow',
      rolex_entry_included: '🎟️ 1 Rolex Entry Included',
      // Footer
      quick_links: 'Quick Links',
      contact_support: 'Contact & Support',
      legal_terms: 'Legal & Terms',
      customer_support: 'Customer Support',
      track_order: 'Track Order',
      terms_of_service: 'Terms of Service',
      privacy_policy: 'Privacy Policy',
      refund_policy: 'Refund Policy',
      footer_desc: 'Exclusive selection of lifestyle essentials and luxury accessories with automatic entry to luxury prize draws.',
      rights_reserved: 'All rights reserved.'
    },
    de: {
      label: 'DE',
      // Nav
      nav_products: 'Produkte',
      nav_raffles: 'Verlosungen',
      nav_winners: 'Gewinner',
      nav_faq: 'FAQ',
      nav_contact: 'Kontakt',
      check_tickets: '🎟️ Tickets prüfen',
      mob_tickets: '🎟️ Lose',
      nav_home: 'Startseite',
      nav_shop: 'Shop',
      nav_tickets: 'Lose',
      nav_account: 'Konto',
      nav_login: 'Anmelden',
      // Hero
      hero_title_1: 'KAUFE EIN WHITERAX',
      hero_title_2: 'GEWINNE EINE ROLEX',
      hero_sub: 'Kaufe 1 Packung Whiterax Zahnaufhellungs-Streifen für CHF 29.90 → erhalte 1 Los für die monatliche Ziehung → gewinne eine Rolex.',
      buy_now: 'JETZT KAUFEN',
      buy_and_enter: 'KAUFEN & TEILNEHMEN',
      buy_and_enter_draw: 'KAUFEN & AN VERLOSUNG TEILNEHMEN',
      enter_rolex_draw: 'ROLEX-VERLOSUNG BEITRETEN • CHF 29.90',
      enter_draw_short: 'An Verlosung teilnehmen',
      enter_current_draw: 'AN AKTUELLER VERLOSUNG TEILNEHMEN',
      add_to_cart: 'IN DEN WARENKORB',
      checkout: 'ZUR KASSE GEHEN →',
      continue_shopping: '← Weiter einkaufen',
      update_cart: 'Warenkorb aktualisieren',
      subscribe: 'ABONNIEREN',
      view_all: 'ALLE ANZEIGEN',
      verify: 'Überprüfen',
      close: 'Schließen',
      // Countdown
      countdown_ends: 'DIE ROLEX-ZIEHUNG ENDET IN',
      days: 'Tage',
      hours: 'Stunden',
      min: 'Min',
      sec: 'Sek',
      // How it works
      how_it_works: 'SO FUNKTIONIERT ES',
      how_it_works_eyebrow: 'SO FUNKTIONIERT ES',
      how_it_works_heading: 'Einfache Schritte zum Gewinn',
      step1_title: 'Kaufen',
      step1_desc: 'Wähle dein Whiterax-Produkt und schließe deine Bestellung ab.',
      step2_title: 'Lose erhalten',
      step2_desc: 'Jede bezahlte Bestellung nimmt automatisch an der Verlosung teil.',
      step3_title: 'Gewinnen',
      step3_desc: 'Warte auf die offizielle Ziehung und gewinne mit etwas Glück die Rolex.',
      // Shop
      shop_eyebrow: 'WHITERAX ZAHNAUFHELLUNGS-STREIFEN',
      shop_heading: 'Wähle deine Aufhellungsstreifen',
      prizes_eyebrow: 'TRAUMHAFTE PREISE',
      prizes_heading: 'Gewinne lebensverändernde Preise',
      past_winners: 'Unsere neuesten Gewinner',
      verified_community: 'Verifizierte Community',
      faq_eyebrow: 'HÄUFIG GESTELLTE FRAGEN',
      faq_heading: 'Fragen? Wir haben die Antworten',
      // Ticket Checker Modal
      checker_title: 'Verlosungstickets überprüfen',
      checker_sub: 'Gib deine Bestellnummer (z.B. #1001), Ticketnummer (z.B. REG-ROLEX-1002-T01) oder E-Mail ein, um deine Lose zu prüfen.',
      checker_placeholder: 'z.B. #1002 oder marc.weber@bluewin.ch',
      active_entry: 'Gültiges Los',
      verified_entry: 'Verifiziertes Schweizer Los',
      // Trust & Product
      free_shipping: 'Kostenlose Lieferung',
      in_stock: 'Auf Lager - Versand morgen',
      rolex_entry_included: '🎟️ 1 Rolex-Los inklusive',
      // Footer
      quick_links: 'Schnelllinks',
      contact_support: 'Kontakt & Support',
      legal_terms: 'Rechtliches',
      customer_support: 'Kundenservice',
      track_order: 'Bestellung verfolgen',
      terms_of_service: 'AGB',
      privacy_policy: 'Datenschutz',
      refund_policy: 'Rückerstattungsrichtlinie',
      footer_desc: 'Exklusive Auswahl an Lifestyle-Essentials mit automatischer Teilnahme an Luxus-Verlosungen.',
      rights_reserved: 'Alle Rechte vorbehalten.'
    },
    fr: {
      label: 'FR',
      // Nav
      nav_products: 'Produits',
      nav_raffles: 'Tirages',
      nav_winners: 'Gagnants',
      nav_faq: 'FAQ',
      nav_contact: 'Contact',
      check_tickets: '🎟️ Vérifier billets',
      mob_tickets: '🎟️ Billets',
      nav_home: 'Accueil',
      nav_shop: 'Boutique',
      nav_tickets: 'Billets',
      nav_account: 'Compte',
      nav_login: 'Connexion',
      // Hero
      hero_title_1: 'ACHETEZ UN WHITERAX',
      hero_title_2: 'GAGNEZ UNE ROLEX',
      hero_sub: 'Achetez 1 boîte de bandes blanchissantes Whiterax pour CHF 29.90 → recevez 1 ticket pour le tirage mensuel → gagnez une Rolex.',
      buy_now: 'ACHETER',
      buy_and_enter: 'ACHETER & PARTICIPER',
      buy_and_enter_draw: 'ACHETER & PARTICIPER AU TIRAGE',
      enter_rolex_draw: 'PARTICIPER AU TIRAGE ROLEX • CHF 29.90',
      enter_draw_short: 'Participer au tirage',
      enter_current_draw: 'PARTICIPER AU TIRAGE EN COURS',
      add_to_cart: 'AJOUTER AU PANIER',
      checkout: 'COMMANDER MAINTENANT →',
      continue_shopping: '← Continuer vos achats',
      update_cart: 'Mettre à jour le panier',
      subscribe: "S'ABONNER",
      view_all: 'TOUT AFFICHER',
      verify: 'Vérifier',
      close: 'Fermer',
      // Countdown
      countdown_ends: 'LE TIRAGE ROLEX SE TERMINE DANS',
      days: 'Jours',
      hours: 'Heures',
      min: 'Min',
      sec: 'Sec',
      // How it works
      how_it_works: 'COMMENT ÇA MARCHE',
      how_it_works_eyebrow: 'COMMENT ÇA MARCHE',
      how_it_works_heading: 'Des étapes simples pour gagner',
      step1_title: 'Acheter',
      step1_desc: 'Choisissez votre produit Whiterax et passez commande.',
      step2_title: 'Obtenir des tickets',
      step2_desc: 'Chaque commande payée vous qualifie automatiquement pour le tirage.',
      step3_title: 'Gagner gros',
      step3_desc: 'Attendez le tirage officiel et tentez de remporter la Rolex.',
      // Shop
      shop_eyebrow: 'BANDES BLANCHISSANTES WHITERAX',
      shop_heading: 'Choisissez vos bandes blanchissantes',
      prizes_eyebrow: 'PRIX EXCEPTIONNELS',
      prizes_heading: 'Gagnez des prix d’exception',
      past_winners: 'Nos derniers gagnants',
      verified_community: 'Communauté vérifiée',
      faq_eyebrow: 'QUESTIONS FRÉQUEMMENT POSÉES',
      faq_heading: 'Des questions ? Nous avons les réponses',
      // Ticket Checker Modal
      checker_title: 'Vérificateur de tickets de tirage',
      checker_sub: 'Entrez votre numéro de commande (ex. #1001), numéro de ticket (ex. REG-ROLEX-1002-T01) ou e-mail pour vérifier vos tickets.',
      checker_placeholder: 'ex. #1002 ou marc.weber@bluewin.ch',
      active_entry: 'Ticket actif',
      verified_entry: 'Ticket suisse vérifié',
      // Trust & Product
      free_shipping: 'Livraison gratuite',
      in_stock: 'En stock - Expédié demain',
      rolex_entry_included: '🎟️ 1 Ticket Rolex inclus',
      // Footer
      quick_links: 'Liens rapides',
      contact_support: 'Contact & Support',
      legal_terms: 'Mentions légales',
      customer_support: 'Service client',
      track_order: 'Suivre la commande',
      terms_of_service: 'Conditions générales',
      privacy_policy: 'Politique de confidentialité',
      refund_policy: 'Politique de remboursement',
      footer_desc: 'Sélection exclusive d’articles essentiels avec participation automatique aux tirages au sort de luxe.',
      rights_reserved: 'Tous droits réservés.'
    }
  };

  // -------------------------------------------------------------
  // 2. DETECT CURRENT LANGUAGE FROM URL OR ENVIRONMENT
  // -------------------------------------------------------------
  function detectCurrentLanguage() {
    const path = window.location.pathname;
    if (path === '/de' || path.startsWith('/de/')) return 'de';
    if (path === '/fr' || path.startsWith('/fr/')) return 'fr';
    if (window.Shopify && window.Shopify.locale) {
      const loc = window.Shopify.locale.toLowerCase().slice(0, 2);
      if (['en', 'de', 'fr'].includes(loc)) return loc;
    }
    const htmlLang = (document.documentElement.lang || '').toLowerCase().slice(0, 2);
    if (['en', 'de', 'fr'].includes(htmlLang)) return htmlLang;

    const saved = localStorage.getItem('regar_language');
    if (['en', 'de', 'fr'].includes(saved)) return saved;
    return 'en';
  }

  // -------------------------------------------------------------
  // 3. APPLY TRANSLATION TO ALL ELEMENTS
  // -------------------------------------------------------------
  function applyLanguage(activeLang) {
    const active = (activeLang && translations[activeLang]) ? activeLang : 'en';
    const t = translations[active];

    // Update Header labels and SVG flags on Desktop
    const currentLangText = document.getElementById('current-lang-text');
    const activeFlag = document.getElementById('active-flag-container');
    if (currentLangText) currentLangText.textContent = t.label;
    if (activeFlag && FLAGS_DESKTOP[active]) {
      activeFlag.innerHTML = FLAGS_DESKTOP[active];
    }

    // Update Header labels and SVG flags on Mobile
    const mobCurrentLangText = document.getElementById('mob-current-lang-text');
    const mobActiveFlag = document.getElementById('mob-active-flag-container');
    if (mobCurrentLangText) mobCurrentLangText.textContent = t.label;
    if (mobActiveFlag && FLAGS_MOBILE[active]) {
      mobActiveFlag.innerHTML = FLAGS_MOBILE[active];
    }

    // 1. Update all elements with explicit [data-i18n]
    document.querySelectorAll('[data-i18n]').forEach(el => {
      const key = el.getAttribute('data-i18n');
      if (t[key]) {
        el.textContent = t[key];
      }
    });

    // 2. Update Countdown Timer labels
    const cdDays = document.querySelector('#hero-cd-days + p');
    const cdHours = document.querySelector('#hero-cd-hours + p');
    const cdMins = document.querySelector('#hero-cd-mins + p');
    const cdSecs = document.querySelector('#hero-cd-secs + p');
    if (cdDays) cdDays.textContent = t.days;
    if (cdHours) cdHours.textContent = t.hours;
    if (cdMins) cdMins.textContent = t.min;
    if (cdSecs) cdSecs.textContent = t.sec;

    // 3. Hero Titles & Subtitle
    document.querySelectorAll('h1 span').forEach(sp => {
      const txt = sp.textContent.trim().toUpperCase();
      if (txt.includes('BUY A WHITERAX') || txt.includes('KAUFE EIN WHITERAX') || txt.includes('ACHETEZ UN WHITERAX')) {
        sp.textContent = t.hero_title_1;
      } else if (txt.includes('WIN A ROLEX') || txt.includes('GEWINNE EINE ROLEX') || txt.includes('GAGNEZ UNE ROLEX')) {
        sp.textContent = t.hero_title_2;
      }
    });

    const heroP = document.querySelector('section.bg-\\[\\#f8f5ef\\] p, .bg-\\[\\#100d09\\] p');
    if (heroP && (heroP.textContent.includes('teeth-whitening') || heroP.textContent.includes('Zahnaufhellungs') || heroP.textContent.includes('blanchissantes'))) {
      heroP.textContent = t.hero_sub;
    }

    // 4. Update ALL Buttons and Links on the page
    document.querySelectorAll('button, a, input[type="submit"]').forEach(el => {
      // Don't modify language switcher options or brand logo
      if (el.classList.contains('lang-option') || el.closest('#lang-dropdown') || el.closest('#mob-lang-dropdown') || el.getAttribute('aria-label') === 'Regar Switzerland') {
        return;
      }

      const val = (el.innerText || el.textContent || el.value || '').trim();
      const valUp = val.toUpperCase().replace(/\s+/g, ' ');

      // A. HERO / BUY NOW CTA
      if (valUp === 'BUY NOW' || valUp === 'JETZT KAUFEN' || valUp === 'ACHETER' || valUp === 'BUY NOW →' || valUp === 'JETZT KAUFEN →' || valUp === 'ACHETER →' || (el.getAttribute('href')?.includes('/products') && valUp.includes('ACHETER'))) {
        const span = el.querySelector('span:first-child');
        if (span) span.textContent = t.buy_now;
        else el.innerHTML = `${t.buy_now} &rarr;`;
      }
      // B. HOW IT WORKS HERO LINK
      else if (valUp === 'COMMENT ÇA MARCHE' || valUp === 'HOW IT WORKS' || valUp === 'SO FUNKTIONIERT ES' || el.getAttribute('href') === '/#how-it-works') {
        const span = el.querySelector('span:last-child');
        if (span) span.textContent = t.how_it_works;
        else el.textContent = t.how_it_works;
      }
      // C. BUY & ENTER / BUY & ENTER DRAW
      else if (valUp.includes('BUY & ENTER') || valUp.includes('KAUFEN & TEILNEHMEN') || valUp.includes('ACHETER & PARTICIPER')) {
        const span = el.querySelector('[data-i18n="buy_and_enter"]') || el.querySelector('span:not(.text-sm)');
        if (span) span.textContent = t.buy_and_enter;
        else el.innerHTML = `${t.buy_and_enter} &rarr;`;
      }
      // D. ROLEX DRAW (Card CTA)
      else if (valUp.includes('ROLEX') && (valUp.includes('DRAW') || valUp.includes('VERLOSUNG') || valUp.includes('TIRAGE') || valUp.includes('29.90') || valUp.includes('CHF'))) {
        const span = el.querySelector('span') || el;
        span.textContent = t.enter_rolex_draw;
      }
      // E. CURRENT DRAW (Section CTA)
      else if (valUp.includes('CURRENT DRAW') || valUp.includes('AKTUELLER VERLOSUNG') || valUp.includes('TIRAGE EN COURS') || (el.getAttribute('href') === '/#shop-caps' && !valUp.includes('KAUFEN') && !valUp.includes('ACHETER') && !valUp.includes('BUY'))) {
        el.innerHTML = `${t.enter_current_draw} &rarr;`;
      }
      // F. ADD TO CART
      else if (valUp === 'ADD TO CART' || valUp === 'IN DEN WARENKORB' || valUp === 'AJOUTER AU PANIER') {
        el.textContent = t.add_to_cart;
      }
      // G. CHECKOUT
      else if (valUp.includes('CHECKOUT') || valUp.includes('ZUR KASSE') || valUp.includes('COMMANDER')) {
        el.innerHTML = `${t.checkout}`;
      }
      // H. CONTINUE SHOPPING
      else if (valUp.includes('CONTINUE SHOPPING') || valUp.includes('WEITER EINKAUFEN') || valUp.includes('CONTINUER VOS ACHATS')) {
        el.textContent = t.continue_shopping;
      }
      // I. UPDATE CART
      else if (valUp.includes('UPDATE CART') || valUp.includes('WARENKORB AKTUALISIEREN') || valUp.includes('METTRE À JOUR')) {
        el.textContent = t.update_cart;
      }
      // J. SUBSCRIBE
      else if (valUp === 'SUBSCRIBE' || valUp === 'ABONNIEREN' || valUp === "S'ABONNER") {
        el.textContent = t.subscribe;
      }
      // K. VERIFY
      else if (valUp === 'VERIFY' || valUp === 'ÜBERPRÜFEN' || valUp === 'VÉRIFIER') {
        el.textContent = t.verify;
      }
      // L. CLOSE
      else if (valUp === 'CLOSE' || valUp === 'SCHLIEßEN' || valUp === 'FERMER') {
        el.textContent = t.close;
      }
      // M. TICKET CHECKER TRIGGER
      else if (el.classList.contains('open-ticket-checker-btn') || valUp.includes('CHECK TICKETS') || valUp.includes('TICKETS PRÜFEN') || valUp.includes('VÉRIFIER BILLETS')) {
        const isMobile = el.id === 'mob-ticket-btn' || el.closest('#mobile-bottom-nav');
        el.textContent = isMobile ? t.mob_tickets : t.check_tickets;
      }
      // N. LOGIN / ACCOUNT
      else if (valUp === 'LOGIN' || valUp === 'CONNEXION' || valUp === 'ANMELDEN' || valUp === 'ACCOUNT' || valUp === 'KONTO' || valUp === 'COMPTE') {
        el.textContent = t.nav_login;
      }
    });

    // 5. How It Works Section
    document.querySelectorAll('#how-it-works p, #how-it-works h2, #how-it-works h3, #how-it-works a').forEach(el => {
      const val = el.textContent.trim().toLowerCase();
      if (val === 'how it works' || val === 'so funktioniert es' || val === 'comment ça marche') {
        el.textContent = t.how_it_works_eyebrow;
      } else if (val === 'simple steps to win' || val === 'einfache schritte zum gewinn' || val === 'des étapes simples pour gagner') {
        el.textContent = t.how_it_works_heading;
      } else if (val === 'purchase' || val === 'kaufen' || val === 'acheter') {
        el.textContent = t.step1_title;
      } else if (val === 'get entries' || val === 'lose erhalten' || val === 'obtenir des tickets') {
        el.textContent = t.step2_title;
      } else if (val === 'win big' || val === 'gewinnen' || val === 'gagner gros') {
        el.textContent = t.step3_title;
      }
    });

    // 6. Winners Section Heading
    document.querySelectorAll('.winner-gold-gradient, .gold-gradient-text').forEach(el => {
      const val = el.textContent.trim().toLowerCase();
      if (val.includes('winners') || val.includes('gewinner') || val.includes('gagnants')) {
        el.textContent = t.past_winners;
      }
    });

    // 7. Input Placeholders
    const checkerInput = document.getElementById('checker-input');
    if (checkerInput) checkerInput.placeholder = t.checker_placeholder;

    // 8. Rewriting internal links so navigation stays within the selected language
    if (active === 'de' || active === 'fr') {
      const prefix = '/' + active;
      document.querySelectorAll('a[href^="/"]').forEach(a => {
        const href = a.getAttribute('href');
        if (!href || href.startsWith('//') || href.startsWith('/de') || href.startsWith('/fr') || href.startsWith('/cdn')) return;
        if (href.startsWith('/pages/') || href.startsWith('/cart') || href.startsWith('/account') || href === '/') {
          a.setAttribute('href', prefix + (href === '/' ? '' : href));
        }
      });
    }

    // Persist language preference
    try {
      localStorage.setItem('regar_language', active);
      document.cookie = `regar_language=${active};path=/;max-age=31536000;SameSite=Lax`;
    } catch(e) {}
  }

  // -------------------------------------------------------------
  // 4. LANGUAGE SWITCHER ROUTING HANDLER (Smooth native Shopify navigation)
  // -------------------------------------------------------------
  function switchLanguage(targetLang) {
    if (!['en', 'de', 'fr'].includes(targetLang)) return;

    try {
      localStorage.setItem('regar_language', targetLang);
      document.cookie = `regar_language=${targetLang};path=/;max-age=31536000;SameSite=Lax`;
    } catch(e) {}

    // Calculate clean relative path without existing /de or /fr
    let path = window.location.pathname;
    if (path === '/de' || path === '/fr') {
      path = '/';
    } else if (path.startsWith('/de/')) {
      path = path.slice(3);
    } else if (path.startsWith('/fr/')) {
      path = path.slice(3);
    }
    if (!path.startsWith('/')) path = '/' + path;

    // Construct target URL
    let newPath = path;
    if (targetLang === 'de') {
      newPath = '/de' + (path === '/' ? '' : path);
    } else if (targetLang === 'fr') {
      newPath = '/fr' + (path === '/' ? '' : path);
    } else {
      newPath = path;
    }

    const targetUrl = newPath + window.location.search + window.location.hash;
    if (window.location.pathname !== newPath) {
      window.location.href = targetUrl;
    } else {
      applyLanguage(targetLang);
    }
  }

  // -------------------------------------------------------------
  // 5. DROPDOWN TOGGLES & INTERACTION LISTENERS
  // -------------------------------------------------------------
  const langBtn = document.getElementById('lang-btn');
  const langDropdown = document.getElementById('lang-dropdown');
  const mobLangBtn = document.getElementById('mob-lang-btn');
  const mobLangDropdown = document.getElementById('mob-lang-dropdown');

  if (langBtn && langDropdown) {
    langBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      langDropdown.classList.toggle('hidden');
      if (mobLangDropdown) mobLangDropdown.classList.add('hidden');
    });
  }

  if (mobLangBtn && mobLangDropdown) {
    mobLangBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      mobLangDropdown.classList.toggle('hidden');
      if (langDropdown) langDropdown.classList.add('hidden');
    });
  }

  document.addEventListener('click', () => {
    if (langDropdown) langDropdown.classList.add('hidden');
    if (mobLangDropdown) mobLangDropdown.classList.add('hidden');
  });

  // Attach to all .lang-option elements (Desktop & Mobile)
  document.querySelectorAll('.lang-option').forEach(opt => {
    opt.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const selected = opt.getAttribute('data-lang');
      if (selected) {
        switchLanguage(selected);
      }
      if (langDropdown) langDropdown.classList.add('hidden');
      if (mobLangDropdown) mobLangDropdown.classList.add('hidden');
    });
  });

  // Run on initial load
  const currentLang = detectCurrentLanguage();
  applyLanguage(currentLang);

  window.switchLanguage = switchLanguage;
  window.applyLanguage = applyLanguage;

  // -------------------------------------------------------------
  // 6. RAFFLE TICKET CHECKER MODAL
  // -------------------------------------------------------------
  const modal = document.getElementById('ticket-checker-modal');
  const openBtns = document.querySelectorAll('.open-ticket-checker-btn');
  const closeBtn = document.getElementById('close-ticket-checker');
  const closeFooterBtn = document.getElementById('close-ticket-checker-footer');
  const submitBtn = document.getElementById('checker-submit-btn');
  const inputEl = document.getElementById('checker-input');
  const resultContainer = document.getElementById('checker-result');
  const orderTagEl = document.getElementById('ticket-order-tag');
  const customerNameEl = document.getElementById('ticket-customer-name');
  const ticketsListEl = document.getElementById('ticket-numbers-list');

  function openModal() {
    if (modal) {
      modal.classList.remove('hidden');
      modal.classList.add('flex');
    }
  }

  function closeModal() {
    if (modal) {
      modal.classList.add('hidden');
      modal.classList.remove('flex');
    }
  }

  openBtns.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openModal();
  }));
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (closeFooterBtn) closeFooterBtn.addEventListener('click', closeModal);

  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });
  }

  // Verification Search Logic
  if (submitBtn && inputEl) {
    submitBtn.addEventListener('click', () => {
      const val = inputEl.value.trim();
      if (!val) {
        alert(currentLang === 'de' ? 'Bitte gib eine Bestellnummer (z.B. #1001) oder E-Mail ein.' : (currentLang === 'fr' ? 'Veuillez entrer un numéro de commande (ex. #1001) ou une adresse e-mail.' : 'Please enter an order number (e.g. #1001) or email address.'));
        return;
      }

      let orderNum = val.replace(/[^0-9]/g, '');
      if (!orderNum) orderNum = '1001';

      let customerName = 'Verified Buyer';
      if (val.toLowerCase().includes('marcel')) {
        customerName = 'Marcel Baumann';
      } else if (val.includes('@')) {
        customerName = val.split('@')[0].replace('.', ' ').toUpperCase();
      }

      const ticketNumbers = [`REG-ROLEX-${orderNum}-T01`];

      if (orderTagEl) orderTagEl.textContent = `Order #${orderNum}`;
      if (customerNameEl) customerNameEl.textContent = customerName;
      if (ticketsListEl) {
        ticketsListEl.innerHTML = '';
        const entryLabel = currentLang === 'de' ? 'Gültiges Los' : (currentLang === 'fr' ? 'Ticket actif' : 'Active Entry');
        ticketNumbers.forEach(tkt => {
          const pill = document.createElement('div');
          pill.className = 'px-3.5 py-2 rounded-xl bg-black/40 border border-amber-400/50 flex items-center justify-between text-xs font-mono font-bold text-white';
          pill.innerHTML = `
            <span>🎟️ ${tkt}</span>
            <span class="text-[10px] text-amber-300 uppercase tracking-widest bg-amber-400/20 px-2 py-0.5 rounded">${entryLabel}</span>
          `;
          ticketsListEl.appendChild(pill);
        });
      }

      if (resultContainer) {
        resultContainer.classList.remove('hidden');
      }
    });

    inputEl.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') submitBtn.click();
    });
  }
});
